import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

// Components
import Navbar from '../navbar/Navbar';
import Loader from '../loader/Loader';

// CSS
import '../../css/landing/landing.css';
import '../../css/ecomPages/ecomPages.css';
import Sidebar from '../sidebar/Sidebar';

const FlipkartEcom = ({ auth: { isAuthenticated, user } }) => {
  const [paidButton, setPaidButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // State to manage active library
  const [activeLibrary, setActiveLibrary] = useState('Python');

  useEffect(() => {
    const fetchIpAddress = async () => {
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();

        // Save the IP address in local storage
        localStorage.setItem('userIp', data.ip);
      } catch (error) {
        console.error('Error fetching IP address:', error);
      }
    };

    // Check if the user's IP address is already saved in local storage
    const savedUserIp = localStorage.getItem('userIp');
    if (!savedUserIp) {
      fetchIpAddress();
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated && user) {
      setIsLoading(true);
      // console.log('user Authenticated');
      // console.log('user', user);

      if (user.is_paid) {
        // console.log('paid User', user.is_paid);
        setPaidButton(true);
        setIsLoading(false);
      } else {
        // console.log('no is_paid user');
        setIsLoading(false);
      }
    }
  }, [isAuthenticated, user]);

  const explanationStepsPython = [
    {
      title: 'Install pip',
      description: 'Ensure the pip package is installed.',
    },
    {
      title: 'API Endpoint',
      description: 'Set the URL to send requests.',
    },
    {
      title: 'Request Body',
      description: 'Contains the necessary data to interact with the API.',
    },
    {
      title: 'POST Request',
      description:
        'Sends a request with post() Method. Includes Content-Type: application/json in headers.',
    },
    {
      title: 'Error Handling',
      description: 'Gracefully handle any API errors.',
    },
    {
      title: 'Execution',
      description: 'Call the function to get data.',
    },
  ];

  const explanationStepsJS = [
    {
      title: 'Install Axios',
      description: 'Ensure the axios package is installed.',
    },
    {
      title: 'API Endpoint',
      description: 'Set the URL to send requests.',
    },
    {
      title: 'Request Body',
      description: 'Contains the necessary data to interact with the API.',
    },
    {
      title: 'POST Request',
      description:
        'Sends a request with axios.post(). Includes Content-Type: application/json in headers.',
    },
    {
      title: 'Error Handling',
      description: 'Gracefully handle any API errors.',
    },
    {
      title: 'Execution',
      description: 'Call the function to get data.',
    },
  ];

  const explanationStepsCurl = [
    {
      title: 'API Endpoint',
      description: `The API URL is ${process.env.REACT_APP_API_BASE_URL}/ecomnext/api/ecom-flipkart, which receives POST requests..`,
    },
    {
      title: 'Request Header',
      description:
        '-H "Content-Type: application/json" ensures the request body is sent in JSON format.',
    },
    {
      title: 'Request Body',
      description:
        'The -d flag is used to provide JSON data containing: api_key, zipcode, links',
    },
    {
      title: 'POST Request:',
      description: '-X POST specifies the HTTP method as POST.',
    },
    {
      title: 'Execution',
      description:
        'Run the command in the terminal to send the request and receive a response.',
    },
    {
      title: 'Error Handling',
      description:
        'Any errors will be displayed in the terminal if the request fails.',
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <div className='flex min-h-screen'>
          {/* Sidebar */}
          <div className='w-64'>
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className='flex-1 flex flex-col'>
            {/* Navbar */}
            <div className=''>
              <Navbar />
            </div>

            {/* Main Content */}
            <div className='ecom-pages-content-wrapper flex-1 bg-white'>
              {/* About Flipkart API */}

              <div className='overview-about-ecom-pages-api'>
                {/* Heading */}
                <h2 className='mb-3.5'>Flipkart</h2>

                {/* Subheading */}
                <p className='mb-9'>
                  The Flipkart Scraping API provides a refined mechanism for
                  extracting real-time product information from Flipkart’s vast
                  e-commerce ecosystem. This API necessitates two primary
                  inputs:
                </p>

                <h3 className='mb-3.5'>Zip Code</h3>
                <p className='mb-9'>
                  This parameter delineates the specific geographical region for
                  which product information is to be procured. Given that
                  Flipkart’s inventory and product availability may fluctuate
                  based on location, the accurate specification of the zipcode
                  is paramount.
                </p>

                <h3 className='mb-3.5'>List of products URL</h3>
                <p className='mb-9'>
                  Users are required to furnish a compilation of product URLs,
                  each corresponding to a distinct item within Flipkart’s
                  extensive catalog. This ensures precise and targeted data
                  retrieval for the specified products.
                </p>

                <p className='mb-4'>
                  Upon processing these inputs, the API yields a meticulously
                  structured response encompassing vital details for each
                  product, such as pricing, availability, and additional
                  attributes. Engineered for efficiency, this API is capable of
                  accommodating multiple product URLs within a single request,
                  rendering it particularly advantageous for bulk data
                  extraction. The output provides contemporaneous updates on
                  pricing and stock status, thereby enabling businesses and
                  consumers to remain informed of the dynamic inventory that
                  characterizes Flipkart’s offerings.
                </p>
              </div>

              <div className='max-w-full mx-auto p-8 bg-white shadow-lg rounded-lg'>
                <h1 className='implementation-guide-heading text-3xl mb-6 text-left leading-tight'>
                  How to Implement the Flipkart EcomNext API in Your Application
                </h1>

                {/* Step 1 */}
                <div className='border-l-4 border-gray-600 pl-4 mb-6'>
                  <h2 className='step-number-heading mb-2'>
                    Step 1: Choose Library
                  </h2>

                  {/* Library Selection Section */}
                  <div className='flex items-center space-x-4 mt-4'>
                    <p className='ecom-pages-select-library-heading'>
                      Select library
                    </p>

                    <div className='switch-btn-wrapper flex rounded-full overflow-hidden'>
                      {/* Python Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'Python'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('Python')}
                      >
                        Python
                      </button>
                      <div className='w-px switch-btn-partition'></div>

                      {/* Curl Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'Curl'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('Curl')}
                      >
                        Curl
                      </button>
                      <div className='w-px switch-btn-partition'></div>

                      {/* JavaScript Button */}
                      <button
                        className={`px-4 py-1 transition ${
                          activeLibrary === 'JavaScript'
                            ? 'library-switch-btn-active'
                            : 'library-switch-btn-inactive'
                        }`}
                        onClick={() => setActiveLibrary('JavaScript')}
                      >
                        JavaScript
                      </button>
                    </div>
                  </div>

                  {/* Descriptive Text */}
                  {activeLibrary === 'JavaScript' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      The following guide will help you integrate the EcomNext
                      API into your JavaScript application.
                      <span className='font-semibold text-blue-500'>
                        {' '}
                        JavaScript (Node.js + Axios)
                      </span>
                      .
                    </p>
                  )}

                  {activeLibrary === 'Python' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      The following guide will help you integrate the EcomNext
                      API into your{' '}
                      <span className='font-semibold text-gray-700 bg-gray-100 rounded-md mx-1 px-1'>
                        {' '}
                        Python{' '}
                      </span>{' '}
                      application.
                    </p>
                  )}

                  {activeLibrary === 'Curl' && (
                    <p className='text-lg text-gray-700 mb-6 text-left mt-4'>
                      If you prefer using
                      <span className='font-semibold text-gray-700 bg-gray-100 rounded-md mx-1 px-1'>
                        {' '}
                        cURL{' '}
                      </span>
                      for API requests from the command line, follow the guide
                      below.
                    </p>
                  )}
                </div>

                {/* Step 2 */}
                {activeLibrary === 'JavaScript' && (
                  <div className='border-l-4 border-blue-500 pl-4 mb-6'>
                    <h2 className='step-number-heading mb-2'>
                      Step 2: Install Axios
                    </h2>
                    <p className='text-gray-700 mb-4'>
                      If you haven't already, install the Axios package to make
                      HTTP requests.
                    </p>

                    <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                      <code className='text-green-400'>
                        {`npm install axios`}
                      </code>
                    </pre>
                  </div>
                )}

                {activeLibrary === 'Python' && (
                  <div className='border-l-4 border-blue-500 pl-4 mb-6'>
                    <h2 className='step-number-heading mb-2'>
                      Step 2: Install Requests Library
                    </h2>
                    <p className='text-gray-700 mb-4'>
                      Make sure you have the requests library installed. If not,
                      install it using:
                    </p>

                    <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                      <code className='text-green-400'>
                        {`pip install requests`}
                      </code>
                    </pre>
                  </div>
                )}

                {/* Step 3(Python and JS) and Step 2 (CURL ) */}
                <div className='border-l-4 border-green-500 pl-4'>
                  <h2 className='step-number-heading mb-2'>
                    {activeLibrary === 'Curl'
                      ? 'Step 2: Implementation'
                      : 'Step 3: Implementation'}
                  </h2>

                  <p className='text-gray-700'>
                    Select the appropriate library for your application to
                    interact with the API effectively.
                  </p>

                  {/* Request Method */}
                  <div className='req-method-about-ecom-pages-api mb-9'>
                    {activeLibrary === 'Python' && (
                      <div className='python-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`import requests
import json

# Define the API endpoint
API_ENDPOINT = '${process.env.REACT_APP_API_BASE_URL}
/ecomnext/api/ecom-flipkart'

# Request body
request_data = {
    "api_key": "e769294327655e0ca20970dd7dd1b400",
    "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
    "zipcode": "560038",
    "links": [
        "https://www.flipkart.com/aroma-nb119-care-48-hours-playing
        -time-fast-charging-bluetooth-neckband-earphone-gaming/p/
        itmddc422762999b?pid=ACCGF2CH39JGFZAF&lid=LSTACCGF2CH39JGF
        ZAFELGXVR&marketplace=FLIPKART&store=0pm%2Ffcn&srno=b_1_1&
        otracker=browse&otracker1=hp_rich_navigation_PINNED_neo%2
        Fmerchandising_NA_NAV_EXPANDABLE_navigationCard_cc_2_L2_view
        -all&fm=organic&iid=en_PK-sVaAJtJtdFSAYjUPEcgFQIVr0c7u1VL-
        GXroccYBS2FwUtuLve21-8pKEYkSQ-EGwACA6aaxvaW4B7aUJ3w%3D%3D&
        ppt=hp&ppn=homepage&ssid=hmokxctw8g0000001734603918086"
    ]
}

# Function to fetch API data
def fetch_ecom_data():
    try:
        print("Fetching data, please wait...")

        # Sending POST request
        response = requests.post(API_ENDPOINT, json=request_data,
         headers={'Content-Type': 'application/json'})

        # Check if request was successful
        response.raise_for_status()
        
        # Parse JSON response
        response_data = response.json()
        print("API Response:", json.dumps(response_data, indent=4))
    except requests.exceptions.RequestException as e:
        print("Error fetching data:", e)

# Execute function
fetch_ecom_data()
`}
                          </code>
                        </pre>
                      </div>
                    )}

                    {activeLibrary === 'Curl' && (
                      <div className='curl-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`curl -X POST ${process.env.REACT_APP_API_BASE_URL}
                            /ecomnext/api/ecom-flipkart' \

-H "Content-Type: application/json" \

-d '{
      "api_key":"e769294327655e0ca20970dd7dd1b400",
      "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
      "zipcode":"560038",
      "links":["https://www.flipkart.com/aroma-nb119-care-
      48-hours-playing-time-fast-charging-bluetooth-neckband
      -earphone-gaming/p/itmddc422762999b?pid=ACCGF2CH39JGFZAF
      &lid=LSTACCGF2CH39JGFZAFELGXVR&marketplace=FLIPKART&
      store=0pm/fcn&srno=b_1_1&otracker=browse&otracker1=
      hp_rich_navigation_PINNED_neo/merchandising_NA_NAV_EXPANDABLE
      _navigationCard_cc_2_L2_view-all&fm=organic&iid=en_PK-sVaAJtJt
      dFSAYjUPEcgFQIVr0c7u1VL-GXroccYBS2FwUtuLve21
      -8pKEYkSQ-EGwACA6aaxvaW4B7aUJ3w%3D%3D&ppt=hp&ppn=homepage&
      ssid=hmokxctw8g0000001734603918086"]
    }'`}
                          </code>
                        </pre>
                      </div>
                    )}

                    {activeLibrary === 'JavaScript' && (
                      <div className='javascript-request mt-8'>
                        <pre className='bg-gray-900 text-white p-4 rounded-md overflow-auto'>
                          <code>
                            {`const axios = require('axios');

// Define the API endpoint
const API_ENDPOINT = '${process.env.REACT_APP_API_BASE_URL}
/ecomnext/api/ecom-flipkart';

// Request body
const requestData = {
    api_key: 'e769294327655e0ca20970dd7dd1b400',
    "key_id":"U2FsdGVkX1+RrnShmu3vfqRQnHa/a1f5SmjyEsSLyfI=",
    zipcode: '560038',
    links: [
        'https://www.flipkart.com/aroma-nb119-care-48-hours-playing-time-
        fast-charging-bluetooth-neckband-earphone-gaming/p/itmddc422762999b
        ?pid=ACCGF2CH39JGFZAF&lid=LSTACCGF2CH39JGFZAFELGXVR&marketplace=
        FLIPKART&store=0pm%2Ffcn&srno=b_1_1&otracker=browse&otracker1=hp_
        rich_navigation_PINNED_neo%2Fmerchandising_NA_NAV_
        EXPANDABLE_navigationCard_cc_2_L2_view-all&fm=organic&iid=en_PK-
        sVaAJtJtdFSAYjUPEcgFQIVr0c7u1VL-GXroccYBS2FwUtuLve21
        -8pKEYkSQ-EGwACA6aaxvaW4B7aUJ3w%3D%3D&ppt=hp&ppn=homepage&
        ssid=hmokxctw8g0000001734603918086'
    ]
};

// Function to fetch data from API
const fetchEcomData = async () => {
    try {
        console.log('Fetching data, please wait...');
        
        // Make a POST request to the API
        const response = await axios.post(API_ENDPOINT, requestData, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // Handle API response
        console.log('API Response:', response.data);
    } catch (error) {
        console.error('Error fetching data:', error.response 
        ? error.response.data : error.message);
    }
};

// Call the function
fetchEcomData();
`}
                          </code>
                        </pre>
                      </div>
                    )}
                  </div>
                </div>

                {/* Implementation Explanation */}
                <div className='border-l-4 border-purple-500 pl-4'>
                  <h2 className='step-number-heading mb-4'>
                    {activeLibrary === 'Curl'
                      ? 'Step 3: Explanation of the Code'
                      : 'Step 4: Explanation of the Code'}
                  </h2>
                  {activeLibrary === 'Python' && (
                    <ul className='space-y-4'>
                      {explanationStepsPython.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}

                  {activeLibrary === 'JavaScript' && (
                    <ul className='space-y-4'>
                      {explanationStepsJS.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}

                  {activeLibrary === 'Curl' && (
                    <ul className='space-y-4'>
                      {explanationStepsCurl.map((step, index) => (
                        <li
                          key={index}
                          className='p-4 border border-gray-300 rounded-lg shadow-sm'
                        >
                          <h3 className='text-lg font-semibold text-blue-600'>
                            {step.title}
                          </h3>
                          <p className='text-gray-700'>{step.description}</p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>

                {/* Response JSON */}
                <div className='overview-about-ecom-pages-api border-l-4 border-gray-500 pl-4 mt-4'>
                  <h2 className='mb-3'>
                    {activeLibrary === 'Curl'
                      ? 'Step 4: Expected Response'
                      : 'Step 5: Expected Response'}
                  </h2>
                  <div className='python-request'>
                    <pre
                      className='bg-gray-900 text-white p-4 rounded-md overflow-auto'
                      style={{
                        // maxWidth: '900px',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                      }}
                    >
                      <code
                        style={{
                          whiteSpace: 'pre',
                          overflowX: 'auto',
                          display: 'block',
                        }}
                      >
                        {`{
  "success": true,
  "data": [
    {
      "Product url": "https://www.flipkart.com/samsung-galaxy-watch6-lte/p/
      itm1b6f4e56a10de?pid=SMWGRV9XZQV6UYTM&lid=LSTSMWGRV9XZQV6UYTMGHGJID&
      marketplace=FLIPKART&store=ajy&srno=b_1_2&otracker=browse&fm=organic&
      iid=f85016ad-de97-4f36-a8ae-81b34f694e56.SMWGRV9XZQV6UYTM.SEARCH&ppt=
      browse&ppn=browse&ssid=d9nxdisrjk0000001730110917527",
      "Image url": "https://rukminim2.flixcart.com/image/416/416/xif0q/
      smartwatch/w/x/h/-original-imahfa7xspmxemvj.jpeg?q=70&crop=false",
      "Product Name": "SAMSUNG Galaxy Watch6 LTE  (Graphite Strap, 44mm)",
      "Brand": "",
      "MRP": "41,999",
      "Discounted Price": "18,999",
      "Discount_percentage": "54% off",
      "Total Ratings": "1,015 Ratings",
      "sold_out": "",
      "Product Rating": "4.3",
      "Sales Package": "Smartwatch, Wireless charger, Quick Setup Guide",
      "Model Name": "Galaxy Watch6 LTE",
      "Colour": "Graphite",
      "Dial Shape": "Round",
      "Strap Material": "Rubber, Silicone",
      "Size": "44mm",
      "Water Resistance Depth": "50 m",
      "Usage": "Fitness & Outdoor",
      "Dial Material": "Armor Aluminum",
      "Ideal For": "Men & Women",
      "Compatible OS": "Android",
      "Closure": "Pin Buckle",
      "Sensor": "Accelerometer, Gyro, Barometer, Ambient Light Sensor, Compass",
      "Compatible Device": "Android Smartphones & Tablets",
      "Notification Type": "Text, Vibrate, Ring",
      "Battery Type": "Lithium Ion",
      "Battery Life": "Up to 40 hours",
      "Charger Type": "Wireless Charger",
      "Operating System": "Wear OS",
      "RAM": "2 GB",
      "Number of Cores": "2",
      "Processor Name": "Exynos W930",
      "Processor Speed": "1.4 GHz",
      "Internal Memory": "16 GB",
      "Bluetooth Version": "v5.3",
      "Operating Range": "10 m",
      "Call Features": "Answer, Reject, Silent Calls, Speed Dial",
      "Display Resolution": "480 x 480 Pixel",
      "Display Size": "1.47 inch",
      "Display Type": "Super AMOLED",
      "Other Camera Features": "Mode Switch, Angle Change, Zoom-in/out",
      "Other Fitness Features": "Personalized HR Zones",
      "Language": "Multi Language",
      "Number of Buttons": "2",
      "Other Watch Functions": "One UI 5, Samsung Health, Multi 3P Apps,
       Galaxy Connected Experience, Safety & Emergency, Personalized HR Zone",
      "Audio Features": "Voice Recording",
      "Gesture Control": "Answer Calls, Dismiss alerts & calls, Quick Launch",
      "Width": "44.4 mm",
      "Height": "42.8 mm",
      "Thickness": "9 mm",
      "Weight": "33.3 mm",
      "Domestic Warranty": "1 Year",
      "Special Features": "Touchscreen , Water Resistant , Notification,
       Rechargeable Battery , Call Function , Bluetooth , Wi-Fi , GPS, 
       Messaging Support , Email Support , Backlight Display , Scratch Resistant,
        Calorie Count , Step Count , Heart Rate Monitor , Date & Time Display,
         Compass , Calendar , Alarm Clock , Chronograph , Speaker , Microphone,
         Voice Control",
      "Best Sellers Rank": "No",
      "Generic Name": "Smartwatches",
      "Country of Origin": "India",
      "Manufactured by": "Dixon Technologies(india) Ltd., Plot No.6, Sector 90,
      Noida, Gautam Buddha Nagar, U.P. India",
      "Imported by": "Dixon Technologies(india) Ltd., Plot No.6, Sector 90, 
      Noida, Gautam Buddha Nagar, U.P. India",
      "Packed by": "Dixon Technologies(india) Ltd., Plot No.6, Sector 90, 
      Noida, Gautam Buddha Nagar, U.P. India"
    }
  ]
}
`}
                      </code>
                    </pre>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(FlipkartEcom);
